<template>
  <div v-if="dataModel!=null" class>
    <!-- header start -->
    <van-nav-bar
      title="我的钱包"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <section class="wallet-banner">
      <div class="bd">
        <div class="t14 cf">可提现金额(元)</div>
        <div class="money">{{dataModel.HasCash}}</div>
        <div class="t14 cf">您已累计赚取佣金:{{dataModel.TotalCommission}}元</div>
      </div>
      <div class="ft">
        <router-link to="/CashRecord" class="btn">提现记录</router-link>
        <router-link to="/BankList" class="btn">银行卡</router-link>
      </div>
    </section>

    <section class="btn-area">
      <van-button round :to="'/CashOut?HasCash='+dataModel.HasCash" block color="orange" size="large">我要提现</van-button>
    </section>

    <section class="cash-out-des">
      <div class="title">提现说明</div>
      <p>
        提现最低金额为100元。
        <br />到账时间说明：平台打款后，需等待银行处理，一般1-3个工作日到账。
        <br />提现费率说明：扣交易手续费 10%。
        <br />备注：提现是指把可提取额度转到您的银行卡中,请先点击银行卡按钮添加银行卡。
        <br />
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataModel:null
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init(){
      var that = this;
      that.$store
        .dispatch({
          type: "GetTotalCommissionInfo"
        })
        .then(
          res => {
            console.log(res);
            that.dataModel=res;
          },
          error => {}
        );
      
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.wallet-banner {
  background: url("~@/assets/images/me/wallet-bg.jpg") center no-repeat;
  background-size: 100% 100%;
  padding: 20px 25px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.wallet-banner > .bd {
  flex: 1;
  overflow: hidden;
}
.wallet-banner > .bd .money {
  font-size: 68px;
  font-weight: 500;
  color: #fff;
  line-height: 1.4;
}
.wallet-banner > .ft {
  margin-left: 15px;
}
.wallet-banner > .ft .btn {
  display: block;
  font-size: 14px;
  color: #fff;
  box-sizing: content-box;
  border: 1px solid #fff;
  height: 26px;
  line-height: 26px;
  width: 82px;
  text-align: center;
  border-radius: 999px;
  margin-bottom: 30px;
}
.cash-out-des {
  margin: 24px 15px;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
}
.cash-out-des .title {
  font-size: 17px;
  color: #555;
  text-align: center;
  margin-bottom: 20px;
}
.cash-out-des p {
  font-size: 13px;
  color: #666;
}
</style>
